import { render, staticRenderFns } from "./TotalOrderTable.vue?vue&type=template&id=17dc2a35"
import script from "./TotalOrderTable.vue?vue&type=script&lang=js"
export * from "./TotalOrderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports